import Vue from 'vue';
import {
  login
} from "./login.js";
import {
  companyHome
} from "./companyHome.js";
import {
  companyAccount
} from "./companyAccount.js";
import {
  companyRole
} from "./companyRole.js";
import {
  companyInvoice
} from "./companyInvoice.js";
import {
  companyStatement
} from "./companyStatement.js";
import {
  companyOrderList
} from "./companyOrderList.js";
import {
  companyOrg
} from "./companyOrg.js";
import {
  companyTeam
} from "./companyTeam.js";
import {
  companyApprove
} from "./companyApprove.js";
import {
  newCompany
} from "./newCompany.js";

export var $request = Object.assign(login, companyHome, companyAccount, companyRole, companyInvoice, companyStatement,
  companyOrderList, companyOrg, companyTeam,companyApprove,newCompany);
Vue.prototype.$request = $request;



// WEBPACK FOOTER //
// ./src/api/api.js